import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAtom } from 'jotai'
import { restoreOrderIdAtom } from '@!/atoms/paymentAtom'
import { useJumpLastUrl } from '@!/Hooks'
import { useGmoPayment } from '@!/components/CreditCard/hooks/useGmoPayment'
import NewCardView from '@!/User/Payment/components/NewCard'

export const NewCard = () => {
  const navigate = useNavigate()
  const { handleGetGmoToken } = useGmoPayment()
  const jumpLastUrl = useJumpLastUrl()
  const location = useLocation()
  const [restoreOrderId] = useAtom(restoreOrderIdAtom)

  useEffect(() => {
    if (!restoreOrderId) {
      jumpLastUrl()
      return
    }
  }, [restoreOrderId, jumpLastUrl])

  const onSubmit = async (data, setError) => {
    const result = await handleGetGmoToken(data, setError)
    if (result.success) {
      navigate('/confirm')
    }
  }

  const pageBack = (e) => {
    e.preventDefault()

    const from = location.state?.from
    if (from === 'RestoreRoot') {
      jumpLastUrl()
      return
    }

    navigate(-1)
  }

  return <NewCardView onSubmit={onSubmit} pageBack={pageBack} />
}

export default NewCard
